import styled from 'styled-components';

interface DonutChartProps {
  myScore: number;
  avgScore: number;
  hasScore: boolean;
  hasAvgScore: boolean;
}

const DonutChart = (props: DonutChartProps) => {
  const { myScore, avgScore, hasScore, hasAvgScore } = props;

  return (
    <>
      <DonutContainer>
        {/* 나의 점수 */}
        <DonutBox>
          <StyledSVG viewBox="0 0 200 200">
            {/* cx, cy:  원의 중심의 x,y 좌표 r: 반지름 크기 */}
            <OuterCircle cx="100" cy="100" r="90" />
            <ProgressCircle
              cx="100"
              cy="100"
              r="90"
              colorfulType={true}
              progress={hasScore ? myScore / 100 : 80 / 100}
            />
            <InnerCircle cx="100" cy="100" r="70" />
          </StyledSVG>
          <Text colorfulType={true}>
            {hasScore ? (
              <>
                나
                <br />
                <span>{myScore}점</span>
              </>
            ) : (
              <>
                나
                <br />
                <span>??점</span>
              </>
            )}
          </Text>
        </DonutBox>
        {/* 평균 점수 */}
        <DonutBox>
          <StyledSVG viewBox="0 0 200 200">
            {/* cx, cy:  원의 중심의 x,y 좌표 r: 반지름 크기 */}
            <OuterCircle cx="100" cy="100" r="90" />
            <ProgressCircle
              cx="100"
              cy="100"
              r="90"
              colorfulType={false}
              progress={hasAvgScore ? avgScore / 100 : 80 / 100}
            />
            <InnerCircle cx="100" cy="100" r="70" />
          </StyledSVG>
          <Text colorfulType={false}>
            {hasAvgScore ? (
              <>
                IVY 평균
                <br />
                <span>{avgScore}점</span>
              </>
            ) : (
              <>
                IVY 평균
                <br />
                <span>??점</span>
              </>
            )}
          </Text>
        </DonutBox>
      </DonutContainer>
    </>
  );
};

export default DonutChart;

const DonutContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.4rem;
`;

//전체 크기 지정
const DonutBox = styled.div`
  position: relative;
  width: 11rem;
  height: 11rem;
`;

const StyledSVG = styled.svg`
  width: 100%;
  height: 100%;
`;

//외부 원
const OuterCircle = styled.circle`
  fill: none;
  stroke: var(--neutral-gray-200);
  stroke-width: 10;
`;

//진행 정도를 표시해주는 원
const ProgressCircle = styled.circle<{ progress: number; colorfulType: boolean }>`
  fill: none;
  stroke: ${(props) =>
    props.colorfulType ? 'var(--primary-ivy-green-600)' : 'var(--neutral-gray-500)'};
  stroke-width: 10;
  stroke-dasharray: ${(props) => 2 * Math.PI * 90}; //원의 둘레로 점선의 패턴을 정의
  stroke-dashoffset: ${(props) =>
    2 * Math.PI * 90 * (1 - props.progress)}; //선이 그려지는 시작 위치를 조절
  stroke-linecap: round; //선 끝을 둥글게
  transform: rotate(-90deg); //디자인에 맞게 회전
  transform-origin: center;
`;

const InnerCircle = styled.circle`
  //안쪽 원
  fill: var(--neutral-white);
`;

const Text = styled.div<{ colorfulType: boolean }>`
  //글씨 위치
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  text-align: center;

  font-family: Pretendard;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: ${(props) => (props.colorfulType ? 'var(--neutral-gray-900)' : 'var(--neutral-gray-700)')};

  span {
    font-size: 2.4rem;
    color: ${(props) =>
      props.colorfulType ? 'var(--primary-ivy-green-600)' : 'var(--neutral-gray-700)'};
  }
`;
